import React, { useContext, useState } from "react";
import { globalContext } from "../components/Layout/Layout";
import "../styles/contact.css";
import {
  Container,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { toggleRegister, toggleLogin } from "../Features/authSlice";
import axios from "axios";
import { constants } from "../Utils/constants";

function Register() {
  // const { toggleRegister, signUpModal, toggleLogin, loginModal } =
  //   useContext(globalContext);

  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    gender: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const signUpModal = useSelector((state) => state.auth.signUpModal);
  const loginModal = useSelector((state) => state.auth.loginModal);

  const handleChange = (e) => {
    setUserDetails({ ...userDetails, [e.target.name]: e.target.value });
  };

  const handleSubmit = async() => {
    if (userDetails.firstName.trim() === "") {
      toast.error("First name cannot be empty !!!", { theme: "colored" });
    } else if (userDetails.lastName.trim() === "") {
      toast.error("Last name cannot be empty !!!", { theme: "colored" });
    } else if (userDetails.email.trim() === "") {
      toast.error("Email field cannot be empty !!!", { theme: "colored" });
    } else if (
      !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
        userDetails.email
      )
    ) {
      toast.error("Email address is not valid !!!", {
        theme: "colored",
      });
    } else if (userDetails.mobile.trim() === "") {
      toast.error("Mobile field cannot be empty !!!", { theme: "colored" });
    } else if (!/^\d{10}$/.test(userDetails.mobile)) {
      toast.error("Mobile No. is not valid !!!", { theme: "colored" });
    } else if (userDetails.password.trim() === "") {
      toast.error("Paasword field cannot be empty !!!", { theme: "colored" });
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        userDetails.password
      )
    ) {
      toast.error("Paasword is not strong enough !!!", {
        theme: "colored",
      });
    } else if (userDetails.gender.trim() === "") {
      toast.error("Gender field is not selected !!!", { theme: "colored" });
    } else {
      dispatch(toggleRegister());

      try {
        const resp = await axios.post(constants.serverUrl+"/user/signup", {...userDetails});
        console.log(resp.data);
        if(resp.data?.status==false){
          toast.success(resp.data?.message);
        }else{
          // navigate("/home");
          dispatch(toggleLogin())
          toast.success("Registration Successfull !!!");
        }
      } catch (err) {
        
      }
    
      
    }
  };

  return (
    <Container className="">
      <Modal isOpen={signUpModal} backdrop="static">
        <ModalHeader
          className="d-flex justify-content-center border-0"
          toggle={() => dispatch(toggleRegister())}
        >
          <h3>
            <strong>Sign Up</strong>
          </h3>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Form method="post">
              <FormGroup floating>
                <Input
                  id="exampleFirstName"
                  name="firstName"
                  placeholder="Enter First Name"
                  type="text"
                  onChange={handleChange}
                />
                <Label for="exampleFirstName">First Name</Label>
              </FormGroup>{" "}
              <FormGroup floating>
                <Input
                  id="exampleLastName"
                  name="lastName"
                  placeholder="Enter Last Name"
                  type="text"
                  onChange={handleChange}
                />
                <Label for="exampleSurname">Last Name</Label>
              </FormGroup>{" "}
              <FormGroup floating>
                <Input
                  id="exampleEmail"
                  name="email"
                  placeholder="Enter Email Address"
                  type="text"
                  onChange={handleChange}
                />
                <Label for="exampleEmail">Email Address</Label>
              </FormGroup>{" "}
              <FormGroup floating>
                <Input
                  id="exampleMobile"
                  name="mobile"
                  placeholder="Enter Mobile No"
                  type="number"
                  onChange={handleChange}
                />
                <Label for="exampleMobile">Mobile No.</Label>
              </FormGroup>{" "}
              <FormGroup floating>
                <Input
                  id="examplePassword"
                  name="password"
                  placeholder="Enter Password"
                  type="password"
                  onChange={handleChange}
                />
                <Label for="examplePassword">Password</Label>
              </FormGroup>
              <FormGroup className="mx-1">
                <Label>Select Gender:</Label>
                <Input
                  className="mx-2"
                  floating
                  type="radio"
                  id="male"
                  name="gender"
                  label="Male"
                  value="M"
                  onChange={handleChange}
                />
                <Label className="mx-1">Male</Label>
                <Input
                  floating
                  className="mx-2"
                  type="radio"
                  id="female"
                  name="gender"
                  label="Female"
                  value="F"
                  onChange={handleChange}
                />
                <Label className="mx-1">Female</Label>
              </FormGroup>
              <div className="text-center d-flex justify-content-center flex-column text-md-start mt-4 pt-2">
                {/* <Button
                    className="contact__btn"
                    size="lg"
                    onClick={toggleRegister}
                  >
                    Sign Up
                  </Button> */}
                <button
                  className=" contact__btn"
                  type="button"
                  onClick={handleSubmit}
                >
                  Register
                </button>
                <p className="small fw-bold mt-2 pt-1 mb-2">
                  Already have an account?{" "}
                  <a
                    href="#"
                    className="credentialsGuards"
                    onClick={() => {
                      dispatch(toggleRegister());
                      if (!loginModal) dispatch(toggleLogin());
                      document.body.style.overflow = "visible";
                    }}
                  >
                    Log in
                  </a>
                </p>
              </div>
            </Form>
          </Row>
        </ModalBody>
      </Modal>
    </Container>
  );
}

export default Register;
